import { evidenceFresh } from './evidenceFreshness';

export const powerFieldLabels = {
  interactive: 'Interactive', displayState: 'Display state', wakefulness: 'Wakefulness', dreaming: 'Dreaming',
  dozing: 'Dozing', powerSave: 'Power save', deviceIdle: 'Device idle', lightDeviceIdle: 'Light device idle',
  holdingWakeLockSuspendBlocker: 'Wake-lock suspend blocker held', holdingDisplaySuspendBlocker: 'Display suspend blocker held',
  lastWakeReason: 'Last wake reason', lastSleepReason: 'Last sleep reason',
};

export function resolvePowerObservations(liveState, details, now = Date.now()) {
  const candidates = [liveState?.state?.nativePowerObservation, details?.native].filter(Boolean)
    .sort((a, b) => Number(b.collectedAt) - Number(a.collectedAt));
  const native = candidates.find((sample) => evidenceFresh(sample, now)) || candidates[0] || null;
  const oldCandidates = [liveState?.state?.externalApp, details?.legacyNative].filter(Boolean)
    .sort((a, b) => Number(b.collectedAt) - Number(a.collectedAt));
  const legacy = oldCandidates.find((sample) => evidenceFresh(sample, now)) || oldCandidates[0] || null;
  const adb = details?.adb || null;
  const nativeFields = {};
  if (evidenceFresh(native, now)) Object.keys(powerFieldLabels).forEach((key) => {
    if (native[key]?.status === 'observed' && native[key].value != null) nativeFields[key] = native[key];
  });
  if (!nativeFields.interactive && evidenceFresh(legacy, now) && typeof legacy.displayInteractive === 'boolean') {
    nativeFields.interactive = { status: 'observed', value: legacy.displayInteractive, legacy: true };
  }
  const fields = {}; const disagreements = [];
  Object.keys(powerFieldLabels).forEach((key) => {
    const a = evidenceFresh(adb, now) && adb.fields?.[key]?.status === 'observed' && adb.fields[key].value != null ? adb.fields[key] : null;
    const n = nativeFields[key];
    if (n && a && n.value !== a.value) disagreements.push(key);
    fields[key] = n ? { ...n, provider: 'native' } : a ? { ...a, provider: 'adb' } : null;
  });
  const value = (key) => fields[key]?.value;
  const display = value('displayState');
  const interactive = value('interactive');
  let summary = { state: 'unknown', label: 'Power unknown' };
  if (disagreements.length) summary = { state: 'conflict', label: 'Power observations disagree' };
  else if (['DOZE', 'DOZE_SUSPEND'].includes(display)) summary = { state: 'dozing', label: `Dozing · ${display}` };
  else if (value('dreaming') === true) summary = { state: 'dreaming', label: `Screensaver / dreaming${display ? ` · display ${display}` : ''}` };
  else if (display === 'OFF') summary = { state: 'asleep', label: interactive === false ? 'Display off / standby' : 'Display off · interactivity unknown' };
  else if (display === 'ON' && interactive === true) summary = { state: 'awake', label: 'Awake / display on' };
  else if (interactive === false) summary = { state: 'noninteractive', label: `Non-interactive · display ${display || 'unknown'}` };
  else if (display) summary = { state: 'unknown', label: `Display ${display} · interactivity unknown` };
  else if (interactive === true) summary = { state: 'awake', label: 'Interactive · display unknown' };
  return { summary, fields, disagreements, native, legacy, adb };
}
